const SECRETS_KEY = "thredd-sandbox-client-secrets";

const readSecrets = (): Map<string, string> => {
  try {
    const raw = sessionStorage.getItem(SECRETS_KEY);
    if (!raw) return new Map();
    return new Map(Object.entries(JSON.parse(raw) as Record<string, string>));
  } catch {
    return new Map();
  }
};

const persistSecrets = (secrets: Map<string, string>): void => {
  try {
    const obj = Object.fromEntries(secrets.entries());
    sessionStorage.setItem(SECRETS_KEY, JSON.stringify(obj));
  } catch {}
};

const secrets = readSecrets();

export const storeCredentialSecret = (id: string, secret: string): void => {
  secrets.set(id, secret);
  persistSecrets(secrets);
};

export const getCredentialSecret = (id: string): string | undefined => {
  return secrets.get(id);
};

export const removeCredentialSecret = (id: string): void => {
  secrets.delete(id);
  persistSecrets(secrets);
};

export const clearAllCredentialSecrets = (): void => {
  secrets.clear();
  try {
    sessionStorage.removeItem(SECRETS_KEY);
  } catch {}
};
